// Adds .is-loaded to every eligible <img> so CSS can transition opacity+blur.
// Reveal is gated on BOTH (a) the image being decoded and (b) the image being
// in the viewport — otherwise a cached hero image flips to .is-loaded long
// before the user scrolls past the theme's own scroll-trigger wrapper, and
// no fade is ever observed.
//
// The double-rAF before adding the class forces the browser to paint the
// opacity:0 / blur state once before transitioning, so the fade runs even
// for images that are already complete + already on screen.
//
// Skipped: anything matching the .no-image-fade opt-out, e.g. logos.
(() => {
  const SKIP_SELECTOR = ".no-image-fade, .header__heading-logo-wrapper img";

  const reveal = (img) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => img.classList.add("is-loaded"));
    });
  };

  const io =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) => {
            for (const e of entries) {
              if (e.isIntersecting) {
                reveal(e.target);
                io.unobserve(e.target);
              }
            }
          },
          { rootMargin: "100px" },
        )
      : null;

  const queueReveal = (img) => {
    if (io) io.observe(img);
    else reveal(img);
  };

  const mark = (img) => {
    if (img.dataset.fadeBound) return;
    if (img.matches(SKIP_SELECTOR)) {
      img.classList.add("is-loaded");
      return;
    }
    img.dataset.fadeBound = "1";
    if (img.complete && img.naturalWidth > 0) {
      queueReveal(img);
      return;
    }
    img.addEventListener("load", () => queueReveal(img), { once: true });
    img.addEventListener("error", () => queueReveal(img), { once: true });
  };

  const scan = (root) => {
    if (root.nodeType !== 1) return;
    if (root.tagName === "IMG") mark(root);
    root.querySelectorAll && root.querySelectorAll("img").forEach(mark);
  };

  scan(document.documentElement);

  new MutationObserver((records) => {
    for (const r of records) for (const n of r.addedNodes) scan(n);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
